import api from './api';

export const transactionService = {
  getAll: (params?: any) => api.get('/balance/transactions', { params }),
  getStats: (params?: any) => api.get('/balance/transactions-stats', { params }),
  exportToExcel: (params?: any) => api.get('/balance/transactions-export', { params, responseType: 'blob' })
};